module.exports = __webpack_public_path__ + "static/img/12.f5f0f17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhwhyx/12.jpg
// module id = jXXX
// module chunks = 1